import * as React from 'react';

import { cn } from '@sunfish/lib/utils';
import { Button } from './button';
import { SunfishMark } from './sunfish-mark';

export function ErrorHero({
	code,
	title,
	body,
	actionLabel,
	actionHref,
	logoUrl,
	fullPage,
	className,
}: {
	code?: string;
	title: string;
	body: string;
	actionLabel: string;
	actionHref: string;
	logoUrl?: string | null;
	fullPage?: boolean;
	className?: string;
}) {
	return (
		<div
			className={cn(
				'relative flex w-full items-center overflow-hidden bg-blue-500',
				fullPage
					? 'min-h-screen justify-center px-8 py-16'
					: 'min-h-[340px] max-w-4xl rounded-[20px] px-14 py-[52px] dark:border dark:border-white/10 max-sm:px-8 max-sm:py-10',
				className
			)}
		>
			<SunfishMark className="pointer-events-none absolute -right-[90px] top-1/2 h-[380px] w-[380px] -translate-y-1/2 text-white/5" />
			<div className="relative flex items-center gap-11 max-sm:flex-col max-sm:items-start max-sm:gap-6">
				<SunfishMark className="h-[150px] w-[150px] shrink-0 text-brand motion-safe:animate-bob max-sm:h-24 max-sm:w-24" />
				<div>
					{logoUrl && <img src={logoUrl} alt="" className="mb-4 max-h-12 w-auto" />}
					{code && (
						<div className="font-display text-[90px] font-extrabold leading-[0.85] tracking-tighter text-white/[0.14]">
							{code}
						</div>
					)}
					<h1 className="font-display mt-1.5 text-4xl font-extrabold leading-none tracking-tight text-white">
						{title}
					</h1>
					<p className="mt-3.5 max-w-[340px] text-base font-medium text-white/70">{body}</p>
					<Button variant="brand" size="lg" className="mt-5 rounded-full font-extrabold" asChild>
						<a href={actionHref}>{actionLabel}</a>
					</Button>
				</div>
			</div>
		</div>
	);
}
